import { create } from "zustand";
import { DirectDebtPaymentMethodChangeFormData } from "src/schemas/DirectDebtFormSchema";

interface FormState {
  accountData?: DirectDebtPaymentMethodChangeFormData;
  updateAccountData: (data: DirectDebtPaymentMethodChangeFormData) => void;
  clearAccountData: () => void;
}

const useFormStore = create<FormState>((set) => ({
  accountData: undefined,
  updateAccountData: (data) => set({ accountData: data }),
  clearAccountData: () => set({ accountData: undefined }),
}));

export default useFormStore;
